import { render, staticRenderFns } from "./StoreLayout.vue?vue&type=template&id=8d043740&scoped=true"
import script from "./StoreLayout.vue?vue&type=script&lang=js"
export * from "./StoreLayout.vue?vue&type=script&lang=js"
import style0 from "./StoreLayout.vue?vue&type=style&index=0&id=8d043740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d043740",
  null
  
)

export default component.exports